import { render, staticRenderFns } from "./applyForWork.vue?vue&type=template&id=25ffd752&"
import script from "./applyForWork.vue?vue&type=script&lang=js&"
export * from "./applyForWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports